<app-banner-app [retroSelected]="false"></app-banner-app>
<br><br>
<div class="textoArriba">
    <br><br><br><br><br><br>
</div>

<div class="container">
    <div class="row">
        <div class="col-sm-6 col-md-5 offset-md-2 col-lg-6 offset-lg-0">
            <div class="textoArriba">
                <div class="aliniacionTexto">
                    <p class="texto1">Tu pago ha sido aprobado</p>
                    <p class="texto2">
                        Te enviaremos un correo con la confirmación y los detalles de tu seguro.
                    </p>
                </div>
                <div class="aliniacionTexto">
                    <img class="styleImage img-responsive" src="./../../assets/img/FeedBackManos.png" />
                </div>
            </div>

            <div class="textoAbajo">
                <div class="aliniacionTexto">
                    <img class="styleImage img-responsive" src="./../../assets/img/FeedBackManos.png" />
                </div>
                <div class="aliniacionTexto">
                    <p class="texto1">Tu pago ha sido aprobado</p>
                    <p class="texto2">
                        Te enviaremos un correo con la confirmación y los detalles de tu seguro.
                    </p>
                </div>
                <br>
            </div>
        </div>

        <div class="col-sm-6 col-md-5 offset-md-2 col-lg-6 offset-lg-0">
            <div class="esAvisos">Información de pago</div>
            <hr style="border: 1px #81B1FF solid">

            <div class="divInfoPago">
                <span class="es-InfoPago_titulo">Estado</span>
                <span class="es-InfoPago_Detalle">Aprobado</span>
                <span class="es-InfoPago_titulo">Valor</span>
                <span class="es-InfoPago_Detalle">$ {{ precioPlanSeleccionado }}</span>
                <span class="es-InfoPago_titulo">Código respuesta</span>
                <span class="es-InfoPago_Detalle">00</span>
                <span class="es-InfoPago_titulo">Referencia de pago</span>
                <span class="es-InfoPago_Detalle">550139237849</span>
                <span class="es-InfoPago_titulo">Forma de pago</span>
                <span class="es-InfoPago_Detalle">N/A</span>
            </div>
            <br><br>

            <div class="esAvisos">Resumen de compra</div>
            <hr style="border: 1px #81B1FF solid">

            <div class="card rounded-9 shadow">
                <p class="card-header card-header">
                    <br>
                    <span class="textoPrincipalCard">Plan {{ 'Seleccionado' }}</span>
                    <br>
                    <span class="textoOrigen">Dirección: {{ 'Direccion' }}</span>
                </p>
                <div class="card-body">
                    <div class="container" style="padding-left: 40px;">
                        <div class="row">
                            <div class="col" style="padding-top: 6px;">
                                <span class="tipoLetra">
                                    <strong style="color: #0033A0;">Propietario:</strong>
                                </span>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col">
                                <span class="tipoLetra">
                                    <strong style="color: #0033A0;">B***** F***** G***Z</strong>
                                </span>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col">
                                <span class="tipoLetra">
                                    <strong style="color: #0033A0;">C.C. 12********41</strong>
                                </span>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col">
                                <span class="tipoLetra">
                                    <strong style="color: #0033A0;">Bogotá</strong>
                                </span>
                            </div>
                        </div>
                    </div>
                    <hr>

                    <div style="padding-left: 30px;" class="tipoLetra">
                        <span style="padding-left: 10px;" class="estiloFecha">Coberturas:</span>
                        <ul style="list-style-image:url(../assets/img/cheque.png); padding-top: 10px;"
                            *ngIf="this.planSeleccionado">
                            <li style="padding-top: 8px;"
                                >
                                <div class="estiloViñetas">{{ 'Prueba' }}</div>
                            </li>
                        </ul>
                    </div>
                    <hr>

                    <div style="padding-left: 40px;" class="tipoLetra">
                        <span class="textoPoliza">Fecha de inicio del contrato de arriendo</span>
                        <br>
                        <span class="estiloFecha">02/05/2024</span>
                    </div>
                    <hr>

                    <div class="estiloTotal">
                        <div class="container">
                            <div class="row">
                                <div class="col-auto alineacionDivTotal">
                                    <span class="variante">Pago Total</span>
                                </div>
                                <div class="col-auto">
                                    <span class="variante">$ {{ this.precioPlanSeleccionado }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br><br>

                </div>
            </div>
            <br><br><br>

            <div style="width: 70%;" class="container">
                <button class="btn btn-primary w-100 py-2 botonContinuar" type="submit"
                    (click)="entiendo()">Entendido</button>
            </div>
        </div>
    </div>
</div>
<br><br><br><br>

<app-footer-app />